/** Match results screen + offline economy — keep formulas in sync. */

export function duelResultsCoinsForOutcome(
  outcome: "win" | "loss" | "draw",
  myScore: number,
): number {
  const ys = myScore;
  if (outcome === "win") return 500 + Math.floor(ys / 12);
  if (outcome === "draw") return 340 + Math.floor(ys / 15);
  return 180 + Math.floor(ys / 18);
}

export function duelResultsXpForOutcome(
  outcome: "win" | "loss" | "draw",
  myScore: number,
): number {
  const ys = myScore;
  if (outcome === "win") return 50 + Math.floor(ys / 35);
  if (outcome === "draw") return 38 + Math.floor(ys / 38);
  return 28 + Math.floor(ys / 40);
}
